import React, { Component} from 'react'
import Theme from "./../../assets/Theme";
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import Subscribe from './../../components/Subscribe';
//import { Route, Redirect } from 'react-router-dom';
import {Box, Link, Typography} from '@material-ui/core';
//import config from "./../../store/config/config.json";

import {Paper, Grid} from '@material-ui/core';
import LoginForm from '../../forms/LoginForm';


export default class LoginPage extends Component {
    /* constructor(props) {
        super(props)

    } */

    render() {
        const tokenClient = this.props.match.params.token
      
        let config = require(`./../../store/config/${tokenClient}/config.json`);

        return (
            <Theme>
                <div className={`wrapper wrapper-${config.client.name}`} styles={config.styles}>
                    <Header misReservas={config.misReservas} isLogin={config.credential.isLogin} client={config.client} header={config.header} sessionState={true}/>
                    <Box className="search-form-section" component="section" display="flex" alignItems="center" p={1} m={1}>
                       {/*  <BgMask className="bgMask bgLogin" /> */}
                        <div className="page-maxwidth login">
                            <Paper className="login-form">
                                <Typography className="title">Inicio de Sesión</Typography>
                                <LoginForm tokenClient={tokenClient}/>
                                <Grid container>
                                    <Grid item xs={6}><Link href={config.links.loginRecover} target="_blank">¿Olvidaste tu clave?</Link></Grid>
                                    <Grid item xs={6} className="text-right"><Link href={config.links.loginRegister} target="_blank">¿No tenés usuario?</Link></Grid>
                                </Grid>  
                            </Paper>
                        </div>
                    </Box>
                    <Subscribe />
                    <Footer data={config.footer} client={config.client} />  
                </div>
            </Theme>
        )
    }
}
